import i18n from '@/utils/i18n';
import defaultSettings from '@/settings'
import store from '@/store'
// || defaultSettings.title
const title = i18n.t('common.title') || 'EaseHUB PMS'

export default function getPageTitle(pageTitle) {
  const customTitle = store.state.app.currentColorLogo.title
  const appTitle = customTitle || title || defaultSettings.title

  if (pageTitle) {
    return `${pageTitle} - ${appTitle}`
  }
  return `${appTitle}`
}
